import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { LoadingBannerComponent } from './loading-banner.component';

@NgModule({
  imports: [CommonModule],
  declarations: [LoadingBannerComponent],
  exports: [LoadingBannerComponent],
})
export class LoadingBannerModule {}
